const appName = "GST Prime";
const API_BASE_URL = (import.meta.env.REACT_APP_API_BASE_URL || 'http://localhost:3000').replace(/\/$/, '');

// Versioned API base — use this for all API calls.
// Unversioned API_BASE_URL is kept for non-API uses (e.g. image URLs, OAuth redirects).
const API_V1 = `${API_BASE_URL}/api/v1`;

const NOTIFICATIONS_ENDPOINT = `${API_V1}/notifications`;

export {
    appName,
    API_BASE_URL,
    API_V1,
    NOTIFICATIONS_ENDPOINT,
}